import React from 'react';
import background from '../../assets/ask-land.jpg';
import ReusableAskearth from '../../components/ReusableAskearth/ReusableAskearth';

class AskLand extends React.Component {
  render () { 
   return(
  
  <ReusableAskearth             
    
        tag="ASK EARTH"
        description01="Have rising temperatures compromised life on land?"

        
        background={background}
     />
  
  );
 }
}   

export default AskLand;